//@flow

import React from "react";

import * as style from "@/components/SliderSteps/slider-steps.module.scss";
import { classNameOf } from "@/utils";

type Props = {
    current: number,
    count: number,
    onSlideSelected: (slide: number) => void,
};

/**
 * Steps/Pagination for a Slider component.
 */
const SliderSteps = ({current, count, onSlideSelected}: Props): React$Element<"div"> => {
    // Generate an array from 0 to {count}, use spread operator to convert iterable to array.
    const indexes = [...new Array<number>(count).keys()];

    if (indexes.length > 1) {
        // Generate a list of steps to display.
        const steps = indexes.map(slideIndex => (
            <div
                key={slideIndex}
                onClick={() => onSlideSelected(slideIndex)}
                className={classNameOf({
                    [style.step]: true,
                    [style.stepActive]: slideIndex === current,
                })}
            />
        ));

        return <div className={style.sliderSteps}>{steps}</div>;
    }

    // Return empty steps if there is less than 2 slides.
    return <div className={style.sliderSteps} />;
};

export default SliderSteps;
